export const dashboard = {
    pageBackground: '#f9f9f9',
    surface: '#FFFFFF',

    surfaceSunk: '#EFEEE9',
    surfaceMuted: '#F4F5F7',
    surfaceHover: '#FBFAF8',
    ink: '#17181C',
    ink2: '#5B6069',
    ink3: '#8B8F98',
    line: '#E4E2DC',
    line2: '#D3D0C8',
    ok: '#1C7A56',
    okBackground: '#E3F2EA',
    warn: '#A8680C',
    warnBackground: '#FAF0DC',
    bad: '#B93327',
    badBackground: '#FBEAE7',
    accentBackground: '#FCEFE6',

    radius: '10px',
    radiusLarge: '14px',

    meterTrack: '#DEDBD3',
    meterFill: '#9B9A93',
    meterFillWarn: '#D89A2E',

    aiFill: '#7C5CFC'
};

export const METER_WARN_RATIO = 0.85;

/** The height the stacked cards in the left column share, so Analytics and "Your Zakeke setup" read the same. */
export const DASHBOARD_CARD_HEIGHT = '140px';
